package org.moxultimate.topwithmox.tech.di

import org.koin.dsl.module
import org.moxultimate.topwithmox.tech.api.TechRepository
import org.moxultimate.topwithmox.tech.ui.TechViewModel

/**
 * techModule
 * Koin module for the Tech/How-To read-only feature.
 * Reuses the shared HttpClient singleton registered by another feature module (e.g. showsModule).
 */
val techModule = module {
    // Repository — singleton; holds no mutable state so it is safe to share
    single { TechRepository(httpClient = get()) }

    // ViewModel — factory so each composable gets a fresh instance with its own scope
    factory { TechViewModel(repository = get()) }
}
